// removed by extract-text-webpack-plugin
module.exports = {"container":"_2tINcUI","body":"_1UGQQJn"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Header/index.css
// module id = ./template/components/Header/index.css
// module chunks = client.sitechrome